import $ from 'jquery';
import moment from 'moment';
import 'moment';
import 'vendors/semantic-daterangepicker/daterangepicker';

export function index() {
  $.fn.datepicker.dates['fr'] = {
    days: [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi',
    ],
    daysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    daysMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    months: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Saptembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ],
    monthsShort: [
      'Jan',
      'Fev',
      'Mar',
      'Avr',
      'Mai',
      'Jui',
      'Juil',
      'Aou',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    today: "Aujourd'hui",
    clear: 'Effacer',
    format: 'dd/mm/yyyy',
    titleFormat: 'MM yyyy',
    weekStart: 1,
  };

  const startDate = moment()
    .subtract(1, 'months')
    .startOf('month');
  const endDate = moment()
    .subtract(1, 'months')
    .endOf('month');

  $('input.datepicker').datepicker({
    language: 'fr',
    autoclose: true,
    orientation: 'bottom',
  });

  // DateRange
  $('input.daterange').daterangepicker({
    language: 'fr',
    format: 'DD/MM/YY',
    opens: 'left',
    startDate: startDate,
    endDate: endDate,
    locale: {
      applyLabel: 'Appliquer',
      cancelLabel: 'Fermer',
      fromLabel: 'De',
      toLabel: 'à',
      weekLabel: 'S',
      customRangeLabel: 'Période personnalisée',
      daysOfWeek: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
      monthNames: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
        '_'
      ),
      firstDay: 1,
    },
  });

  $('.daterange.selectionInput').val(
    startDate.format('DD/MM/YY') + ' - ' + endDate.format('DD/MM/YY')
  );
}



// WEBPACK FOOTER //
// ./src/modules/saas/exports/index.js